import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import PopUp from 'react/shared/components/popups/PopUp';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import TrueLinkChip from 'react/shared/components/true_link/main/TrueLinkChip';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/TrueLinkRadios';
import AtmAccessInfo from 'react/signups/card/common/AtmAccessInfo';

export default function EditAtmAccessModal({ atmAccess, firstName, onClose, onChangeAtmAccess }) {
  const validationSchema = Yup.object().shape({
    atmAccess: Yup.string(),
  });

  const handleContinue = (values) => {
    onChangeAtmAccess(values.atmAccess);
  };

  const options = [
    {
      label: (
        <>
          No <TrueLinkChip color="primary" label="MOST COMMON" size="small" />
        </>
      ),
      value: 'no',
    },
    {
      label: 'Yes',
      value: 'yes',
    },
  ];

  return (
    <PopUp
      header={`Will ${firstName} be making cash withdrawals from an ATM using this card?`}
      headerComponent={'h2'}
      onClose={onClose}
      openModal
      padding="30px"
    >
      <Formik
        initialValues={{ atmAccess }}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleChange, handleSubmit, values }) => (
          <>
            <TrueLinkRadios
              ariaLabel="Do you need ATM access questionnaire"
              name="atmAccess"
              onChange={handleChange}
              options={options}
              value={values.atmAccess}
            />
            <AtmAccessInfo atmAccess={values.atmAccess} />
            <NextPageButton label="Done" onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </PopUp>
  );
}

EditAtmAccessModal.propTypes = {
  atmAccess: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeAtmAccess: PropTypes.func.isRequired,
};
